const defaultNonMeaningfulValues = [null, undefined, '', 0, '0'];

export function hasMeaningfulValues<T extends { [key: string]: any }>(
  obj: T | null,
  nonMeaningfulValues: unknown[] = defaultNonMeaningfulValues,
): obj is NonNullable<T> {
  if (!obj) {
    return false;
  }

  function isMeaningful(value: any): boolean {
    return !nonMeaningfulValues.includes(value);
  }

  function checkObject(currentObj: { [key: string]: any }): boolean {
    for (const [, value] of Object.entries(currentObj)) {
      if (typeof value === 'object' && value !== null) {
        if (checkObject(value)) {
          return true;
        }
      } else if (isMeaningful(value)) {
        return true;
      }
    }
    return false;
  }

  return checkObject(obj);
}
